<template>
  <div>
    <div class="flex mb-5">
      <div class="w-6/12">
        <h1 class="text-xl font-bold text-gray-700">Outfitters</h1>
      </div>
      <div class="w-6/12">
        <el-switch
            v-if = "userHasAdmin()"
          class="mr-5"
          v-model="withDeleted"
          active-text="Inactive"
          inactive-text="Active"
          :active-value="1"
          :inactive-value="0"
          @change="handleWithDeletedChange"
        >
        </el-switch>
        <base-button-primary v-if = "userHasAdmin()" @click="newOutfitter" class="float-right"
          >New Outfitter</base-button-primary
        >
      </div>
    </div>
    <div class="mb-3">
      <div class="w-full">
        <vue-good-table
          :columns="columns"
          :rows="outfitters"
          :search-options="{ enabled: true }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'name', type: 'asc' },
          }"
          :fixed-header="false"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 50,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            dropdownAllowAll: false,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'id'">
              <span v-if = "userHasAdmin()">
                              <base-button-primary-extra-small
                                  @click="handleEdit(props.row)">
                Edit
              </base-button-primary-extra-small>
              <base-button-primary-extra-small
                  @click="handleDashboard(props.row)"
                  class="ml-3"
              >
                Dashboard
              </base-button-primary-extra-small>

              <base-button-white-extra-small
                  v-if="!props.row.deleted_at"
                  @click="handleDelete(props.row)"
                  class="ml-3"
              >
                Make Inactive
              </base-button-white-extra-small>
              <base-button-white-extra-small
                  v-else
                  @click="handleRestore(props.row)"
                  class="ml-3"
              >
                Restore
              </base-button-white-extra-small>
              </span>
              <span v-else>

              <base-button-primary-extra-small
                  @click="handleDisplayGroups(props.row)"
                  class="ml-3"
              >
                Display Groups
              </base-button-primary-extra-small>

              </span>

            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <base-modal :show="showModal" @close="showModal = false" @save="save">
      <template v-slot:header> Outfitter </template>
      <template v-slot:main>
        <div class="grid grid-cols-2 gap-4">
          <div>
            <base-label>Name</base-label>
            <base-input v-model="outfitter.name" />
          </div>
          <div>
            <base-label>Email</base-label>
            <base-input v-model="outfitter.email" />
          </div>
          <div>
            <base-label>Photo Expiration</base-label>
            <base-input v-model="outfitter.photo_expire" />
          </div>
          <div>
            <base-label>On Home Page</base-label>
            <el-switch
              v-model="outfitter.on_home_page"
              active-text="Yes"
              inactive-text="No"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import Validator from "../common/Validator";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import BaseInput from "@/components/ui/forms/BaseInput";
import userFunctions from "../../mixins/userFunctions";
export default {
  name: "Outfitters",
  components: { BaseInput, VueGoodTable },
  mixins: [userFunctions],
  data() {
    return {
      showModal: false,
      outfitter: {
        id: null,
        name: "",
        email: "",
        photo_expire: 10,
        on_home_page: 1,
      },
      withDeleted: false,
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Email",
          field: "email",
        },
        {
          label: "",
          field: "id",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    handleDashboard(row) {
      this.$store
        .dispatch("auth/set_outfitter_id", row.id)
        .then((outfitter_id) => {
          this.$store.dispatch("outfitter/reload_outfitter", outfitter_id);
        });
      this.$router.push("/dashboard");
    },
    handleDisplayGroups(row) {
      this.$store
          .dispatch("auth/set_outfitter_id", row.id)
          .then((outfitter_id) => {
            this.$store.dispatch("outfitter/reload_outfitter", outfitter_id);
          });
      this.$router.push("/dashboard/display-groups");
    },
    handleWithDeletedChange() {
      this.$store.dispatch("outfitter/reload", {
        withDeleted: this.withDeleted,
      });
    },
    setOutfitter(row = null) {
      if (row) {
        this.outfitter = {
          id: row.id,
          name: row.name,
          email: row.email,
          photo_expire: row.photo_expire,
          on_home_page: row.on_home_page,
        };
      } else {
        this.outfitter = {
          id: null,
          name: "",
          email: "",
          photo_expire: 10,
          on_home_page: 1,
        };
      }
    },
    newOutfitter() {
      this.setOutfitter();
      this.showModal = true;
    },
    handleEdit(row) {
      this.setOutfitter(row);
      this.showModal = true;
    },
    handleDelete(row) {
      if (confirm("Are you sure you want to remove this outfitter?")) {
        this.$store
          .dispatch("outfitter/delete_outfitter", { id: row.id })
          .then((resp) => {
            if (!resp.success) return;

            this.$store.dispatch("outfitter/reload", {
              withDeleted: this.withDeleted,
            });
            this.$notify({
              title: "Outfitter",
              message: "The outfitter has been removed",
              type: "success",
            });
          });
      }
    },
    handleRestore(row) {
      this.$store
        .dispatch("outfitter/restore_outfitter", { id: row.id })
        .then((resp) => {
          if (!resp.success) return;

          this.$store.dispatch("outfitter/reload", {
            withDeleted: this.withDeleted,
          });
          this.$notify({
            title: "Outfitter",
            message: "The outfitter has been restored",
            type: "success",
          });
        });
    },
    save() {
      if (
        !Validator([
          { field: this.outfitter.name, name: "Outfitter Name" },
          { field: this.outfitter.email, name: "Outfitter Email" },
        ])
      ) {
        return;
      }
      this.$store
        .dispatch("outfitter/save_outfitter", this.outfitter)
        .then((resp) => {
          if (!resp.success) return;

          this.$store.dispatch("outfitter/reload", {
            withDeleted: this.withDeleted,
          });
          this.$notify({
            title: "Outfitter",
            message: "Data Saved",
            type: "success",
          });
          this.showModal = false;
          this.setOutfitter();
        });
    },
  },
  computed: {
    outfitters: function () {
      return this.$store.getters["outfitter/getOutfitters"];
    },
  },
  mounted() {
    this.$store.dispatch("outfitter/all", { withDeleted: this.withDeleted });
  },
};
</script>

<style scoped></style>
